module.exports = __webpack_public_path__ + "static/khorshidnet-logo-7fed9aa100e535aa53bd0ea12dcb7b41.jpg";